import React, {useState, useEffect} from "react";

import {ReactComponent as FiatGroup} from '../../assets/img/Group 70.svg';
import '../../assets/styles/App.css';
import "@fontsource/montserrat";

import DisbursementChart from "../Charts/DisbursementChart.js"
import CashFlowChart from "../Charts/CashFlowChart.js";

export default function CardInvestorAggregate(props) {

    useEffect(() => {

    }, []);

    return (
        <>

            <div className="px-4 mt-3">
                <div className="relative flex w-full flex-col bg-white-2 rounded-lg p-5 min-w-0 break-words mb-6">

                    <div className="w-full flex items-center">
                        <div className="w-3/12">
                            <div className="relative flex flex-col text-white w-full">
                                <FiatGroup className="size-btc-group"/>
                                {/* <p className="text-12-700 text-center text-white mt-4">Rates</p> */}
                            </div>
                        </div>
                        <div className="w-9/12">
                            <div className="relative flex flex-col w-full px-6">
                                <h2 className="text-24-performance text-white">Total Portfolio Overview</h2>
                                <br />
                            </div>
                        </div>
                    </div>

                    <hr className="mb-4 bigHr"></hr>

                    <p className="pb-2 text-14-400 text-white">
                        NUMBER OF LOANS LAST 12 MONTHS<span
                        className="text-right text-14-600">{(props.chartData.total_loans).toLocaleString(undefined, { minimumFractionDigits: 0 })}</span>
                    </p>


                </div>
            </div>

            <div className="flex flex-wrap">

                <div className="relative md:w-6/12 lg:w-6/12 px-4 mb-4">
                    <div className="relative bg-white-2 w-full rounded-lg p-3 mb-8">

                        <DisbursementChart
                            dataset={props.chartData.disbursed_usd}
                            labels={props.chartData.reporting_year_month}
                            title='Monthly Disbursement (USD)'
                            subtitle="Disbursements"/>

                    </div>
                </div>

                <div className="relative md:w-6/12 lg:w-6/12 px-4 mb-4">
                    <div className="relative bg-white-2 w-full rounded-lg p-3 mb-8">

                        <CashFlowChart
                            dataset={props.chartData.customer_count}
                            labels={props.chartData.reporting_year_month}
                            title='Customers Served'
                            subtitle="Monthly Customers Served"/>

                    </div>
                </div>

            </div>


        </>
    );
}
